module.exports = __webpack_public_path__ + "static/media/96.40e66b98.jpg";